import { createAction, props } from '@ngrx/store';

export const setCustomerCurrency = createAction('[Customer API] Set Customer Currency', props<{ currencyCode: string }>());

export const setContractCurrency = createAction('[Contract API] Set Contract Currency', props<{ currencyCode: string }>());
